import React from "react";

const NotFound = ({
  card = true,
  width = "100%",       // dynamic width
  height = "auto",      // dynamic height
  title = "404 - Page Not Found",
  path ,           // redirect path
  theme_color = "var(--primary-color)" // icon and button color
}) => {

  const Content = (
    <div
      style={{
        width,
        height,
        textAlign: "center",
        padding: "20px",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        viewBox="0 0 24 24"
        fill="none"
        stroke={theme_color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginBottom: "10px" }}
      >
        <path stroke="none" d="M0 0h24v24H0z" />
        <path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3" />
        <path d="M4 6v6c0 1.657 3.582 3 8 3c1.118 0 2.182 -.086 3.148 -.241m4.852 -2.759v-6" />
        <path d="M4 12v6c0 1.657 3.582 3 8 3c1.064 0 2.079 -.078 3.007 -.22" />
        <path d="M19 16v3" />
        <path d="M19 22v.01" />
      </svg>

      <h3 className="fw-semi-bold fs-3">{title}</h3>

      {path && (
        <a
          href={path}
          style={{
            marginTop: "15px",
            display: "inline-block",
            padding: "8px 16px",
            border: `1px solid ${theme_color}`,
            color: theme_color,
            borderRadius: "6px",
            textDecoration: "none",
            fontSize: "14px",
          }}
        >
          Go Back
        </a>
      )}
    </div>
  );

  return card ? (
    <div className="card" style={{ width }}>
      <div className="card-body">{Content}</div>
    </div>
  ) : (
    Content
  );
};

export default NotFound;
